/* Hero slideshow: fade between slides, pause on hover and when off-screen,
 * dots and arrow keys for control. A single slide stays completely static.
 */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.lkHeroReady === 'true') return;
    root.dataset.lkHeroReady = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-lk-slide]'));
    if (slides.length < 2) {
      if (slides[0]) slides[0].classList.add('is-on');
      return;
    }

    var dotsWrap = root.querySelector('[data-lk-dots]');
    var delay = Math.max(2000, parseInt(root.dataset.interval, 10) || 5000);
    var autoplay = root.dataset.autoplay !== 'false';
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var index = 0;
    var timer = null;
    var dots = [];

    if (dotsWrap) {
      slides.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'lk-hero__dot';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.addEventListener('click', function () { go(i); restart(); });
        dotsWrap.appendChild(b);
        dots.push(b);
      });
    }

    function go(n) {
      index = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        s.classList.toggle('is-on', i === index);
        s.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-on', i === index);
        d.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      if (!autoplay || reduce || timer) return;
      timer = setInterval(function () { go(index + 1); }, delay);
    }
    function restart() { stop(); start(); }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    root.setAttribute('tabindex', '-1');
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { go(index + 1); restart(); }
      if (e.key === 'ArrowLeft') { go(index - 1); restart(); }
    });

    // swipe
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
      x0 = null;
      start();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { en.isIntersecting ? start() : stop(); });
      }, { threshold: 0.2 }).observe(root);
    } else {
      start();
    }

    go(0);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-lk-hero]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
